export enum DecimalMarker {
    Coma = ',',
    Dot = '.'
}
